import {Button, Chip, Input, Option, Select, Textarea, Typography} from "@material-tailwind/react";
import Dict from "../../../helper/dict";
import React, {useContext, useEffect, useState} from "react";
import "../../../style/datePicker.css"
import {createAgentLog, createAgentLogNew} from "../../../services/agent/agent_log";
import FileInput from "../../system/fileInput";
import {getProvinces} from "../../../services/province/province";
import SelectInput from "../../system/select";
import {getProvinceCities} from "../../../services/city/city";
import {trim} from "lodash/string";
import DateField from "../../system/dateField";
import {AgentRequestContext} from "../../../context/agent_context";
import {getDegrees} from "../../../services/degree/degree";
import {getStageDegrees} from "../../../services/stage_degree/stage_degree";

export function AgentsForm() {

  const {
    agentId,
    agentRequest,
    setAgentRequest,
    agentLog,
    setAgentLog,
    modalOpen,
    setModalOpen,
    confirmationComments,
    setLastDataRefresh
  } = useContext(AgentRequestContext)

  const [provinceId, setProvinceId] = useState(agentRequest?.province_id);
  const [cityId, setCityId] = useState(agentRequest?.city_id);
  const [degreeId, setDegreeId] = useState(agentRequest?.degree_id);
  const [stageDegreeId, setStageDegreeId] = useState(agentRequest?.stage_degree_id);
  const [birthDate, setBirthDate] = useState(agentRequest?.birth_date)

  const [newConfirmationComments, setNewConfirmationComments] = useState(confirmationComments);

  const [comment, setComment] = useState(agentLog?.comment);
  const [statusLog, setStatusLog] = useState(agentLog?.status);

  const save_log = async (status_action) => {
    setAgentLog(agentLog => ({
      ...agentLog,
      status: status_action,
    }))

    const data = {
      agent_log: {
        agent_id: agentId,
        comment: comment,
        status: status_action,
      },
      agent: {
        agent_id: parseInt(agentId),
        ...agentRequest,
        id: parseInt(agentRequest?.agent_tid),
        status: status_action,
      },
    };
    let result;

    if (agentRequest?.agent_tid) {
      data.agent.id = parseInt(agentRequest?.agent_tid);
      result = await createAgentLog(data);
    } else {
      result = await createAgentLogNew(data);
    }

    if (result.status === 200) {
      setAgentLog(result.data);
      setLastDataRefresh(Date.now())
    }
  };

  const handleTap = (title, description) => {
    if (comment?.trim().length === 0 || comment === null) {
      setComment(title + ' - ' + description);
    } else if (!comment.includes(title + ' - ' + description)) {
      setComment(trim(comment + '\n' + title + ' - ' + description));
    } else {
      setComment(trim(comment.replace(title + ' - ' + description, '')));
    }
  };

  useEffect(() => {
    setAgentRequest(agentRequest => ({
      ...agentRequest,
      province_id: provinceId,
    }))
  }, [provinceId]);

  useEffect(() => {
    setAgentRequest(agentRequest => ({
      ...agentRequest,
      city_id: cityId,
    }))
  }, [cityId]);

  useEffect(() => {
    setAgentRequest(agentRequest => ({
      ...agentRequest,
      degree_id: degreeId,
    }))
  }, [degreeId]);

  useEffect(() => {
    setAgentRequest(agentRequest => ({
      ...agentRequest,
      stage_degree_id: stageDegreeId,
    }))
  }, [stageDegreeId]);

  useEffect(() => {
    setAgentRequest(agentRequest => ({
      ...agentRequest,
      birth_date: birthDate,
    }))
  }, [birthDate]);


    return (
      <>
        <div className="grid grid-cols-1 gap-4 p-4 overflow-y-scroll max-w-full md:grid-cols-2 xxl:grid-cols-3">

          <div className="flex w-full mt-2 mb-4">
            <Input variant="standard"
                   value={agentRequest?.name}
                   label={Dict('name')}
                   placeholder={Dict('name')}
                   onChange={(e) => {
                     setAgentRequest(agentRequest => ({
                       ...agentRequest,
                       name: e.target.value,
                     }))
                   }}
            />
          </div>

          <div className="flex w-full mt-2 mb-4">
            <Input variant="standard"
                   value={agentRequest?.family}
                   label={Dict('family')}
                   placeholder={Dict('family')}
                   onChange={(e) => {
                     setAgentRequest(agentRequest => ({
                       ...agentRequest,
                       family: e.target.value,
                     }))
                   }}
            />
          </div>

          <div className="flex w-full mt-2 mb-4">
            <Input variant="standard"
                   value={agentRequest?.phone}
                   label={Dict('phone')}
                   placeholder={Dict('phone')}
                   onChange={(e) => {
                     setAgentRequest(agentRequest => ({
                       ...agentRequest,
                       phone: e.target.value,
                     }))
                   }}
            />
          </div>

          <div className="flex w-full mt-2 mb-4">
            <Input variant="standard"
                   value={agentRequest?.father_name}
                   label={Dict('father_name')}
                   placeholder={Dict('father_name')}
                   onChange={(e) => {
                     setAgentRequest(agentRequest => ({
                       ...agentRequest,
                       father_name: e.target.value,
                     }))
                   }}
            />
          </div>

          <div className="flex w-full mt-2 mb-4">
            <Input variant="standard"
                   value={agentRequest?.national_code}
                   label={Dict('national_code')}
                   placeholder={Dict('national_code')}
                   onChange={(e) => {
                     setAgentRequest(agentRequest => ({
                       ...agentRequest,
                       national_code: e.target.value,
                     }))
                   }}
            />
          </div>

          <div className="col w-full mb-4">
            <DateField
              className="my-4 mx-4 w-full"
              date={agentRequest?.birth_date}
              setDate={setBirthDate}
              label={Dict("birth_date")}
            />
          </div>

          <div className="flex w-full mb-4">
            <Select variant="static" className="rtl" style={{label: {left: ""}}}
                    label={Dict('gender')}
                    value={agentRequest?.gender}
                    onChange={(val) => {
                      setAgentRequest(agentRequest => ({
                        ...agentRequest,
                        gender: val,
                      }))
                    }}
            >
              <Option value="male">مرد</Option>
              <Option value="female">زن</Option>
            </Select>
          </div>

          <div className="col w-full mb-4">
            <SelectInput
              className="w-full"
              label={Dict("province")}
              defaultValue={agentRequest?.province_id}
              autoLoadService={getProvinces}
              onChange={setProvinceId}
            />
          </div>

          {agentRequest?.province_id &&
          <div className="col w-full mb-4">
            <SelectInput
              className="w-full"
              label={Dict("city")}
              defaultValue={agentRequest?.city_id}
              refreshSignal={agentRequest?.province_id}
              autoLoadService={getProvinceCities}
              autoLoadServiceData={agentRequest?.province_id}
              onChange={setCityId}
            />
          </div>
          }

          <div className="col w-full mb-4">
            <Input variant="standard"
                   value={agentRequest?.home_phone}
                   label={Dict('home_phone')}
                   placeholder={Dict('home_phone')}
                   onChange={(e) => {
                     setAgentRequest(agentRequest => ({
                       ...agentRequest,
                       home_phone: e.target.value,
                     }))
                   }}
            />
          </div>

          <div className="col w-full mb-4">
            <Input variant="standard"
                  value={agentRequest?.email}
                  label={Dict('email')}
                  placeholder={Dict('email')}
                  onChange={(e) => {
                    setAgentRequest(agentRequest => ({
                      ...agentRequest,
                      email: e.target.value,
                    }))
                  }}
            />
          </div>

          <div className="col w-full mb-4">
            <SelectInput
              className="w-full"
              label={Dict("degree")}
              defaultValue={agentRequest?.degree_id}
              autoLoadService={getDegrees}
              onChange={setDegreeId}
            />
          </div>

          <div className="col w-full mb-4">
            <SelectInput
              className="w-full"
              label={Dict("stage_degree")}
              defaultValue={agentRequest?.stage_degree_id}
              autoLoadService={getStageDegrees}
              onChange={setStageDegreeId}
            />
          </div>

          <div className="flex w-full mb-4">
            <Textarea
              variant="standard"
              value={agentRequest?.address}
              label={Dict('address')}
              onChange={(e) => {
                setAgentRequest(agentRequest => ({
                  ...agentRequest,
                  address: e.target.value,
                }))
              }}
            />
          </div>

          <div className="col w-full mb-4">
            <Input variant="standard"
                   value={agentRequest?.experience}
                   label={Dict('experience')}
                   placeholder={Dict('experience')}
                   onChange={(e) => {
                     setAgentRequest(agentRequest => ({
                       ...agentRequest,
                       experience: e.target.value,
                     }))
                   }}
            />
          </div>

          <div className="col w-full mb-4">
            <Input variant="standard"
                   value={agentRequest?.speciality}
                   label={Dict('speciality')}
                   placeholder={Dict('speciality')}
                   onChange={(e) => {
                     setAgentRequest(agentRequest => ({
                       ...agentRequest,
                       speciality: e.target.value,
                     }))
                   }}
            />
          </div>

          <div className="flex w-full mb-4">
            <Textarea
              variant="standard"
              value={agentRequest?.about_me}
              label={Dict('about_me')}
              onChange={(e) => {
                setAgentRequest(agentRequest => ({
                  ...agentRequest,
                  about_me: e.target.value,
                }))
              }}
            />
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 p-4 mb-8 overflow-y-scroll max-w-full">

          <div className="flex w-fit mb-4 p-4 md:w-1/2">
            <FileInput
              label={Dict('degree_file')}
              fileCode={agentRequest?.degree_file}
              onChange={(e) => {
                setAgentRequest(agentRequest => ({
                  ...agentRequest,
                  degree_file: e.target.files[0],
                }))
              }}/>
          </div>

          <div className="flex w-fit mb-4 md:w-1/2">
            <FileInput
              label={Dict('resume_file')}
              fileCode={agentRequest?.resume_file}
              onChange={(e) => {
                setAgentRequest(agentRequest => ({
                  ...agentRequest,
                  resume_file: e.target.files[0],
                }))
              }}/>
          </div>

          <div className="flex w-fit mb-4 md:w-1/2">
            <FileInput
              label={Dict('introduction_file')}
              fileCode={agentRequest?.introduction_file}
              onChange={(e) => {
                setAgentRequest(agentRequest => ({
                  ...agentRequest,
                  introduction_file: e.target.files[0],
                }))
              }}/>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-1 mb-8 overflow-y-scroll">

          <div className="flex flex-col w-fit mb-4 md:flex-row">
            <div className="flex flex-row w-fit mb-4">
              {newConfirmationComments &&
                <Typography variant="h6">
                  توضیحات پیشفرض:
                </Typography>
              }
            </div>
            <div className="grid grid-cols-1 gap-4">
              {newConfirmationComments.map(({title, description}) => (
                <div className="flex">
                  <Chip size="sm" className="mx-2 overflow-x-hidden hover:overflow-x-visible cursor-pointer" variant="ghost"
                        value={title + " - " + description}
                        onTap={() => {
                          handleTap(title, description)
                        }}
                  />
                </div>
              ))
              }
            </div>
          </div>

          <div className="flex w-full mb-4">
            <Textarea
              variant="standard"
              value={comment}
              label={Dict('comment_request')}
              onChange={(e) => {
                setComment(e.target.value)
              }}
            />
          </div>
          <div className="text-left w-full mb-4">
            {agentLog?.status && (agentLog?.status !== 'accepted' || agentLog?.status === 'new') &&
              <Button className="mx-2" color="green" variant="outlined"
                      onClick={() => {
                        setStatusLog("accepted");
                        save_log('accepted')
                      }}
              >
                تایید
              </Button>
            }
            {agentLog?.status && (agentLog?.status === 'accepted' || agentLog?.status === 'new') &&
              <Button className="mx-2" color="red" variant="outlined"
                      onClick={() => {
                        setStatusLog("rejected");
                        save_log('rejected')
                      }}>
                عدم‌تایید
              </Button>
            }
          </div>

        </div>
      </>
    );
}